/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-07-01 15:24:29
 * @FilePath: /bar-front-end/src/permission.ts
 */
import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { getCurUserDetailApi } from '@/api/login'
import WsModule from '@/utils/wsModule'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  const wsModule = WsModule

  // 独立企微系统入口不复用综管已有登录态，由入口页自行完成 OAuth 和系统判断。
  if (to.path === '/qywx-system-entry') {
    next()
    return
  }

  // 独立企微入口携带的新 token 优先于当前系统可能残留的旧登录态。
  if (to.path === '/login' && to.query.token) {
    next()
    return
  }

  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (permissionStore.getIsAddRouters) {
        next()
        return
      }

      const res = await getCurUserDetailApi()
      if (res.code === 200) {
        // 连接ws
        wsModule.connectWebSocket()
        // 根据平台类型字段platform过滤 platform： 0:后端，1:前端，2：企微
        const roleRouters = res?.data?.perms?.filter((item) => item.platform === 1)
        // 变更全局路由
        userStore.setRoleRouters(roleRouters)
        // 变更用户信息
        userStore.setUserInfo(res?.data)
        // 是否使用动态路由
        if (appStore.getDynamicRouter) {
          appStore.serverDynamicRouter
            ? await permissionStore.generateRoutes(
                'server',
                roleRouters as AppCustomRouteRecordRaw[]
              )
            : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
        } else {
          await permissionStore.generateRoutes('static')
        }

        permissionStore.getAddRouters.forEach((route) => {
          router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
        })
        const redirectPath = from.query.redirect || to.path
        const redirect = decodeURIComponent(redirectPath as string)

        const path = permissionStore.addRouters[0].path
        const lastPath = permissionStore.addRouters[0]?.children?.[0]?.path
          ? `/${permissionStore.addRouters[0].children[0].path}`
          : ''
        const nextData = to.query.redirect ? { path: redirect } : { ...to, replace: true }
        // const nextData =
        //   to.path === redirect
        //     ? { ...to, path: path + lastPath, replace: true }
        //     : { path: redirect }
        // const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
        permissionStore.setIsAddRouters(true)
        next(nextData)
      }
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      wsModule.closeWebSocket()
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
